import React from 'react';
import { Link } from 'react-router-dom';
import './components.css';

const NewWorkoutButton = () => {
  return (
    <Link to="/new-workout" className="btn-2025 btn-2025-primary shadow-elev inline-flex items-center gap-2 w-auto">
      <div className="mb-0">
        <h3 className="new-workout-button-header">
          <i className="far fa-plus-square"></i> New Workout
        </h3>
      </div>
    </Link>
  );
};

export default NewWorkoutButton;